import script from "./ImageZoom.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageZoom.vue?vue&type=script&setup=true&lang=js"

import "./ImageZoom.vue?vue&type=style&index=0&id=bbb4060e&lang=scss"

const __exports__ = script;

export default __exports__